import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { isEmpty } from "lodash";
import ReactGA from "react-ga4";
import { getUser } from "../../store/slices/user";

const GoogleAnalyticsListener = () => {
    // @ts-ignore;
    const googleTrackingId = process.env.REACT_APP_GOOGLE_ID as string;
    const location = useLocation();
    const currentBrandData = useSelector((state: any) => state.brandsettings.data);
    const currentBrandDataIsLoading = useSelector((state: any) => state.brandsettings.isLoading);
    const authenticateUserData = useSelector((state: any) => state.authenticateuser.data);
    const authenticateUserDataIsLoading = useSelector((state: any) => state.authenticateuser.isLoading);
    const userDataFetched = useSelector((state: any) => state.user.userInfoFetched);
    const userData = useSelector((state: any) => state.user.data);
    const dispatch = useDispatch();

    const [isInitialized, setIsInitialized] = useState(false);


    const doNotTrackUserId = useMemo(() => {
        if (currentBrandDataIsLoading && authenticateUserDataIsLoading) return false;
        let domainSettingsData = {} as any;
        if (!isEmpty(currentBrandData)) {
            domainSettingsData = {...currentBrandData.domainSettings};
        } else if (!isEmpty(authenticateUserData)) {
            domainSettingsData = {...authenticateUserData.domainSettings};
        } else {
            return false;
        }

        return domainSettingsData.doNotTrackUserId;
    }, [currentBrandData, currentBrandDataIsLoading, authenticateUserData, authenticateUserDataIsLoading]);


      const getCleanUrl = () => {
        var url = window.location.href;
        var paramsToRemove = ['auth']; 
      
        try {
          var urlObj = new URL(url);
          paramsToRemove.forEach(function(param) {
            urlObj.searchParams.delete(param);
          });
          return urlObj.toString();
        } catch (e) {
          return url;
        }
      }
    
    useEffect(()=>{
      if (!userDataFetched) {
        dispatch(getUser()) 
      }
    },[dispatch, getUser, userDataFetched]);

    const isNotLocalHost = useMemo(
      () => window.location.origin.indexOf("localhost") === -1,
      []
    );


    // Initialize GA once
    useEffect(() => {
        if (
            !ReactGA.isInitialized &&
            userDataFetched && 
            !userData.admin &&
            isNotLocalHost
        ) {
            const options = doNotTrackUserId ? {} : { user_id: userData.user_token };
            const initialUrl = new URL(window.location.href);
            if (initialUrl.searchParams.has("auth")) {
              initialUrl.searchParams.delete("auth");
            }

            ReactGA.initialize([
                {
                    trackingId: googleTrackingId,
                    gaOptions: options,
                    gtagOptions: { 
                        send_page_view: false,
                        page_location: getCleanUrl() 
                    },
                    
                },
            ]);
            setIsInitialized(true);
        }
    }, [
        userData,
        userDataFetched,
        doNotTrackUserId,
        googleTrackingId,
        isNotLocalHost,
    ]);



     // Track pageviews (after title is set)
  useEffect(() => {

    if (ReactGA.isInitialized) {
      let sent = false;

      const sendPageView = () => {
        if (sent) return;

        const trySend = () => {
          // @ts-ignore
          if (typeof window.gtag === "function") {
            sent = true;
            let pageUrlToSend = new URL(window.location.href);
            pageUrlToSend.searchParams.delete("auth");
            
            ReactGA.send({
              hitType: "pageview",
              page: location.pathname,
              title: document.title,
              page_location: getCleanUrl(),
            });
          } else {
            setTimeout(trySend, 50);
          }
        };

        trySend();
      };

      // reset flag on route change
      document.body.dataset.titleReady = "false";

      const observer = new MutationObserver(() => {
        if (document.body.dataset.titleReady === "true") {
          sendPageView();
          observer.disconnect();
        }
      });

      observer.observe(document.body, { attributes: true, attributeFilter: ["data-title-ready"] });

      return () => {
        observer.disconnect();
      };
    }
  }, [location, userDataFetched, isInitialized]);
    
   return null;
}


export default GoogleAnalyticsListener;